import React, { useCallback } from "react";
import { KButton, KIcon, KTextInput } from "@kyburz/kdesign-system";
import { Divider } from "@material-ui/core";

import { styles, useStyles } from "./styles";

const defaultExportOption = "";

type ExportToSettingsProps = {
  exportOptions: string[];
  setExportOptions: (options: string[]) => void;
};

export const ExportToSettings = ({
  exportOptions,
  setExportOptions,
}: ExportToSettingsProps) => {
  const classes = useStyles();

  const noData = <div className={classes.noData}>No data</div>;

  const addExportOption = useCallback(() => {
    setExportOptions(
      exportOptions
        ? [...exportOptions, defaultExportOption]
        : [defaultExportOption],
    );
  }, [setExportOptions, exportOptions]);

  const deleteExportOption = useCallback(
    (index: number) => {
      if (exportOptions) {
        const updatedExportOptions = [...exportOptions].filter(
          (_, i) => i !== index,
        );
        setExportOptions(updatedExportOptions);
      }
    },
    [setExportOptions, exportOptions],
  );

  const updateExportOption = useCallback(
    (index: number, value: string) => {
      if (exportOptions) {
        const updatedExportOptions = [...exportOptions];
        updatedExportOptions[index] = value;
        setExportOptions(updatedExportOptions);
      }
    },
    [setExportOptions, exportOptions],
  );

  const title = (
    <div className={classes.titleContainer}>
      <div className={classes.title}>
        <div>Export to</div>
        <KButton
          className={classes.button}
          icon={<KIcon icon="plus" />}
          size="medium"
          onClick={addExportOption}
          disabled={exportOptions.length >= 60}
        >
          Add export option
        </KButton>
      </div>
      <Divider className={classes.divider} />
    </div>
  );

  const exportOptionsFields = (
    <div style={styles.options as React.CSSProperties}>
      {exportOptions.map((option: string, index: number) => {
        return (
          <KTextInput
            key={index}
            label="Export to"
            placeholder="Export to"
            endIcon="trash"
            style={styles.option}
            value={option || ""}
            name="exportTo"
            onChange={(value) => updateExportOption(index, value.target.value)}
            onEndIconClick={() => deleteExportOption(index)}
          />
        );
      })}
    </div>
  );

  return (
    <div className={classes.fields}>
      {title}
      {!exportOptions || exportOptions?.length <= 0
        ? noData
        : exportOptionsFields}
    </div>
  );
};

export default ExportToSettings;
